<ng-template [ngIf]="isShowEmptyTemplate">
    <div class="wrapper-no-comment">
        <p>هنوز دیدگاهی ثبت نشده است</p>
    </div>
</ng-template>
<div id="container-star-rate">
    <navaar-container-scroll
        [showHeader]="true"
        [title]="title"
        [show]="isShowRate"
    >
        <div
            class="container-rate-popup"
            (swipedown)="location.back()"
        >
            <p>{{ isShowEmptyTemplate ? 'اولین نفری باشید که دیدگاه خود را ثبت می‌کند' :'امتیاز شما به این اثر' }}</p>
            <div class="wrapper-rate">
                <navaar-star-icon
                    (rate)="rateToComment($event)"
                    [rate-item]="(ratoToComment ? ratoToComment : 0)"
                    [style]="{'width':'26px', 'height': '25px', 'margin':' 0 7px'}"
                ></navaar-star-icon>
            </div>
            <div class="container-textarea">
                <navaar-textarea
                    [(model)]="model.commentText"
                    [length]="500"
                    placeholder="نظر شما در مورد این اثر"
                ></navaar-textarea>
            </div>
            <div style="height: 52px;">
                <navaar-button
                    (onClick)="onSaveComment()"
                    [color-name]="'green'"
                >
                    <p class="save-comment">{{ isLogin ?  'ثبت' : 'ورود و ثبت' }}</p>
                </navaar-button>
            </div>
        </div>
    </navaar-container-scroll>
</div>
